<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs />
          <div class="remind">
            <el-form :model="searchData" inline>
              <el-form-item prop="ntype" :label="$t('消息类型')">
                <el-select v-model="searchData.ntype" size="small" multiple clearable filterable>
                  <el-option
                    v-for="(item, key) in options[msg[active]]"
                    :key="key"
                    :label="item"
                    :value="key"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-checkbox class="no-content-item" v-model="searchData.ntype_ex">
                  排除
                </el-checkbox>
              </el-form-item>
              <el-form-item
                prop="crm_id"
                label="学生CRM ID"
                v-if="active !== 2 && !$hasPermission([108])"
              >
                <el-input v-model="searchData.crm_id" size="small" />
              </el-form-item>
              <el-form-item prop="custom_nickname_tell" :label="$t('学生昵称')">
                <el-input v-model="searchData.custom_nickname_tell" size="small" />
              </el-form-item>
              <el-form-item prop="custom_nickname_tell" :label="$t('生成时间')">
                <el-date-picker
                  v-model="searchData.addtime"
                  type="daterange"
                  align="right"
                  size="small"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="getSearch">{{ $t('查询') }}</el-button>
              </el-form-item>
            </el-form>
            <div class="operation">
              <el-menu
                :default-active="active"
                class="tab-head"
                mode="horizontal"
                @select="fetchData"
              >
                <el-menu-item v-if="this.$siteName === 'teaching'" index="0">
                  {{ $t('状态提醒') }} <el-badge :value="count.status_message" v-if="count.teaching_message" />
                </el-menu-item>
                <el-menu-item v-else index="0">
                  {{ $t('状态提醒') }} <el-badge :value="count.status_message" v-if="count.status_message" />
                </el-menu-item>
                <el-menu-item v-if="this.$siteName === 'fib' || this.$siteName === 'training'" index="1">
                  支付消息 <el-badge :value="count.payment_message" v-if="count.payment_message" />
                </el-menu-item>
                <el-menu-item v-if="this.$siteName === 'fib'" index="2">
                  计划任务 <el-badge :value="count.task_message" v-if="count.task_message" />
                </el-menu-item>
                <!-- !$isOnline  -->
                <el-menu-item v-if="this.$siteName === 'fib'" index="3">
                  问答消息 <el-badge :value="count.question_message" v-if="count.question_message" />
                </el-menu-item>
                <el-menu-item v-if="this.$siteName === 'fib' && $hasPermission([19, 20, 33, 58, 101])" index="4">
                  VIP权益消息 <el-badge :value="count.behaviour_message" v-if="count.behaviour_message" />
                </el-menu-item>
                <el-menu-item v-if="this.$siteName === 'fib' && $hasPermission([20, 33, 101])" index="5">
                  VIP咨询消息 <el-badge :value="count.consult_message" v-if="count.consult_message" />
                </el-menu-item>
                <el-menu-item v-if="this.$siteName === 'fib' " index="6">
                  芥末通知 <el-badge :value="count.engaus_message" v-if="count.engaus_message" />
                </el-menu-item>
              </el-menu>
              <el-button
                type="primary"
                class="clearRemind"
                size="small"
                @click="remindClear"
                v-if="active !== '3'"
              >{{ $t('全部标记已读') }}</el-button>
            </div>
            <jm-tableList
              class="remindList"
              :url="url"
              :refresh="refresh"
              :search-data="searchData"
              :current-page.sync="currentPage"
              @row-click="remindRead"
              :row-class-name="setRowClass"
            >
              <el-table-column slot="firstColumn" type="expand" v-if="active === '3'">
                <template slot-scope="props">
                  <span>{{ props.row.description }}</span>
                </template>
              </el-table-column>
              <el-table-column slot="lastColumn" :label="$t('操作')" width="240" align="center">
                <template slot-scope="scope">
                  <i class="over" @click.stop="return false;" />
                  <div class="btns" style="display: inline-block;">
                    <el-button
                      type="primary"
                      :plain="scope.row.status > 1"
                      :icon="scope.row.status > 1 ? 'el-icon-star-off' : 'el-icon-star-on'"
                      :title="scope.row.status > 1 ? '设为未读' : '设为已读'"
                      class="btn-del"
                      @click.stop="toggleRead(scope)"
                    />
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      title="删除"
                      class="btn-del"
                      @click.stop="remindRemove(scope)"
                      v-if="active === '1' || active === '0'"
                    />
                  </div>
                  <div class="btns" style="position: relative; z-index: 2; display: inline-block;">
                    <router-link
                      v-if="scope.row.extend_data"
                      target="_blank"
                      :to="{
                        name: 'questionAnswer',
                        params: {
                          crmid: scope.row.crm_id,
                          questionId: scope.row.extend_data._tid
                        },
                        query: {
                          currentReplyId: (scope.row.ntype_id === 60 || scope.row.ntype_id === 61) ? '' : scope.row.extend_data._id
                        }
                      }"
                    >
                      <el-button
                        class="rely-but"
                        @click="handelReply(scope)"
                        type="primary"
                        size="mini"
                        v-if="active === '3'"
                      >回复</el-button>
                    </router-link>
                    <router-link
                      v-if="scope.row.extend_data"
                      target="_blank"
                      :to="{ name: 'questionList', params: { crmid: scope.row.crm_id } }"
                    >
                      <el-button
                        class="rely-but"
                        type="primary"
                        size="mini"
                        v-if="active === '3' && (scope.row.ntype_id === 60 || scope.row.ntype_id === 62)"
                      >问题管理</el-button>
                    </router-link>
                  </div>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jmTableList from '@/components/data/tableList';
import permissionMixin from '@/pages/student/permissionMixin';

const pickerOptions = {
  disabledDate(time) {
    // eslint-disable-next-line no-mixed-operators
    return time.getTime() > Date.now() + 3600 * 1000 * 24 - 8.64e7;
  },
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        // eslint-disable-next-line no-mixed-operators
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        // eslint-disable-next-line no-mixed-operators
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        // eslint-disable-next-line no-mixed-operators
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};

const searchData = {
  ntype: [],
  ntype_ex: '',
  crm_id: '',
  custom_nickname_tell: '',
  addtime: '',
  type: 'status_message'
};
export default {
  components: { jmTableList },
  mixins: [permissionMixin],
  data() {
    return {
      msg: [
        'status_message',
        'payment_message',
        'task_message',
        'question_message',
        'behaviour_message',
        'consult_message',
        'engaus_message',
        'teaching_message',
      ],
      options: {
        status_message: {},
        payment_message: {},
        task_message: {},
        question_message: {},
        behaviour_message: {},
        consult_message: {},
        engaus_message: {},
        teaching_message: {},
      },
      searchData: {},
      count: {
        status_message: 0,
        payment_message: 0,
        task_message: 0,
        question_message: 0,
        behaviour_message: 0,
        consult_message: 0,
        engaus_message: 0,
        teaching_message: 0,
      },
      pickerOptions,
      active: '0',
      currentPage: 1,
    };
  },
  computed: {
    // 监听状态刷新数据
    refresh() {
      return this.$store.state.student.refresh;
    },
    typeInterface() {
      if (this.active === '2') {
        return 'planMessage';
      } else if (this.active === '0' || this.active === '1') {
        return 'remindStudent';
      } else if (this.active === '3') {
        return 'remindQuestion';
      } else if (this.active === '4') {
        return 'userActiveVip';
      } else if (this.active === '5') {
        return 'userConsultVip';
      } else if (this.active === '6') {
        return 'remindEngAus';
      }
    },
    url() {
      if (this.$siteName === 'teaching') {
        return '/teaching/messagecenter/getMessages';
      }
      return `/index/system/${this.typeInterface}`;
    }
  },
  methods: {
    setSearchData() {
      this.searchData = Object.assign({}, searchData);
    },
    getSearch() {
      this.searchData.isSearch = false;
      Object.values(this.searchData).forEach((item) => {
        if (item) {
          this.searchData.isSearch = true;
        }
      });
      this.$store.commit('updateRefresh', true);
    },
    fetchCount() {
      let fetchUrl = '/index/system/noRead';
      if (this.$siteName === 'teaching') {
        fetchUrl = '/teaching/messagecenter/noRead';
      }
      return this.$http
        ._get({
          url: fetchUrl
        })
        .then(({ data }) => {
          this.count = data;
          let notifyAmount = Object.values(data).reduce((holder, v) => {
            return v + holder;
          }, 0);
          this.$store.commit('updateMessageAmount', notifyAmount);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchData(key) {
      if (this.active === key) {
        return false;
      }
      this.active = key;
    },
    remindRead(row) {
      if (row.ntype_id >= 60 && row.ntype_id <= 63) {
        return false;
      }
      let fetchRrl = `/index/system/clickRead?type=${this.msg[+this.active]}&id=${row.id}`;
      if (this.$siteName === 'teaching') {
        fetchRrl = `/teaching/messagecenter/changeMsgStatus?status=${row.status}&id=${row.id}`;
      }
      if (row.status === 1) {
        this.$http
          ._get({
            url: fetchRrl
          })
          .then((res) => {
            if (res.result !== 0) {
              this.$message({ message: res.msg, type: 'error' });
              return false;
            }
            row.status = 2;
            this.fetchCount();
          })
          .catch((err) => {
            console.log(err);
          });
      }
      /*
         // 原页面逻辑
         if (this.active === 2 && row.crm_id !== 0) {
         window.open(row.url);
         }
         if (row.is_click === 1) {
         window.location.href = row.url;
         }
         */
      const url = row.jump_url || row.url;
      url && window.open(url);
    },
    toggleRead({ row }) {
      let data = {
        id: row.id,
        status: row.status,
        type: this.typeInterface
      };
      this.replyTemp(data);
    },
    handelReply({ row }) {
      let data = {
        id: row.id,
        status: 1,
        type: this.typeInterface
      };
      this.replyTemp(data);
    },
    replyTemp(data) {
      let url = '/index/system/setRemindStatus';
      if (this.$siteName === 'teaching') {
        url = '/teaching/messagecenter/changeMsgStatus';
      }
      this.$http
        ._post({
          url: url,
          data: Object.assign({}, data)
        })
        .then((res) => {
          this.$message({
            message: res.msg,
            type: res.result !== 0 ? 'error' : 'success'
          });
          if (res.result === 0) {
            this.getSearch();
            this.fetchCount();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    remindRemove(scope) {
      if (scope.row.crm_id === 'undefined') {
        return false;
      }
      let url = `/index/system/deleteRemind?id=${scope.row.id}`;
      if (this.$siteName === 'teaching') {
        url = `/teaching/messagecenter/deleteMsg?id=${scope.row.id}`;
      }
      this.$confirm('确定要删此提醒？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            ._get({
              url: url
            })
            .then((res) => {
              this.$message({
                message: res.msg,
                type: res.result !== 0 ? 'error' : 'success'
              });
              if (res.result === 0) {
                this.getSearch();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          return false;
        });
    },
    remindClear() {
      let url = `/index/system/setReaded?${this.msg[+this.active]}=1`;
      if (this.$siteName === 'teaching') {
        url = `/teaching/messagecenter/readedAll?${this.msg[+this.active]}=1`;
      }
      this.$http
        ._get({
          url: url
        })
        .then((res) => {
          this.$message({
            message: res.msg,
            type: res.result !== 0 ? 'error' : 'success'
          });
          this.getSearch();
          this.fetchCount();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * Description: 设置tr行上class 显示不同效果
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    setRowClass({ row }) {
      let className1 = '';
      let className2 = '';
      let className3 = '';
      if (row.status === 1) {
        className1 = 'unRead';
      }
      if (row.pointer === 0) {
        className3 = 'cursorexpand';
      }
      row.description !== null &&
      row.description !== '' &&
      row.description !== undefined
        ? (className2 = '')
        : (className2 = 'expand');
      return `${className1} ${className2} ${className3}`;
    }
  },
  mounted() {
    this.setSearchData();
    this.$http
      ._get({
        url: '/index/system/remindInterface'
      })
      .then(({ data }) => {
        this.options.status_message = data.status;
        this.options.payment_message = data.payment;
        this.options.question_message = data.question;
        this.options.behaviour_message = data.behaviour;
        this.options.consult_message = data.consult;
        this.options.engaus_message = data.engaus;
      });
    this.$http
      ._get({
        url: '/index/system/planMessageInterface'
      })
      .then(({ data }) => {
        this.options.task_message = data;
      });
    if (this.$siteName === 'teaching') {
      this.$http
        ._get({
          url: '/teaching/messagecenter/getMessageType'
        })
        .then(({ data }) => {
          this.options.status_message = data;
        });
    }
    this.fetchCount();
  },
  watch: {
    active() {
      this.setSearchData();
      this.searchData.type = this.msg[+this.active];
      this.currentPage = 1;
      this.getSearch();
    },
    refresh() {
      this.fetchCount();
    }
  }
};
</script>
<style scoped>
.remind form {
  margin: 0.5em 0;
}

.remind form .el-form-item {
  margin-bottom: 0;
}

.remind .operation {
  position: relative;
  margin-bottom: 15px;
  padding-right: 120px;
}

.remind .operation:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 0;
  display: block;
  width: 100%;
  border-bottom: 1px solid #d0dee5;
}

.remind .tab-head {
  position: relative;
  z-index: 1;
  background-color: transparent;
}

.remind .el-menu--horizontal .el-menu-item {
  padding: 0 15px;
  height: 45px;
  line-height: 45px;
  font-weight: bold;
}

.remind .el-menu--horizontal .el-menu-item:hover {
  background-color: transparent;
  border-bottom: 3px solid transparent;
}

.remind .tab-head span {
  line-height: 12px;
}

.remind .tab-head .hasRemind {
  font-weight: bold;
  color: #be0000;
}

.remind .is-active,
.remind .is-active:hover {
  background-color: transparent;
  border-bottom: 3px solid #20a0ff;
  color: #20a0ff;
}

.remind .clearRemind {
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -1.25em;
}

.remind /deep/ .el-table__row {
  cursor: pointer;
}

.remind /deep/ .unRead {
  font-weight: bold;
}
.remind  /deep/ .cursorexpand {
  cursor: inherit;
}
.remind .btn-del {
  position: relative;
  z-index: 2;
}

.remind .over {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: block;
}

.remind .btns .el-button {
  padding: 4px;
}

.remind .btns .rely-but {
  padding: 7px 15px;
}

.remind /deep/ .expand .el-table__expand-column .cell {
  display: none;
}
</style>
